import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image/index.tsx");
